// EntitySummaryCards.js - Clickable summary cards showing entity counts by type
import React from 'react';
import { ENTITY_TYPE_CONFIG } from '../../services/inventoryService';
import './EntitySummaryCards.css';

function EntitySummaryCards({ facets, activeType, onTypeClick, totalCount }) {
    // Order of entity types to display
    const typeOrder = ['seed', 'subdomain', 'ip', 'port', 'service', 'url', 'finding'];

    // Build cards data from facets
    const cards = typeOrder.map(type => {
        const config = ENTITY_TYPE_CONFIG[type] || { label: type, icon: '📦', color: '#888' };
        const count = facets?.byType?.[type] || 0;
        return {
            type,
            label: config.label,
            icon: config.icon,
            color: config.color,
            count
        };
    }).filter(card => card.count > 0); // Only show types with counts

    if (cards.length === 0) {
        return null;
    }

    return (
        <div className="entity-summary-cards">
            {/* All types card */}
            <button
                className={`summary-card summary-card-all ${activeType === 'all' ? 'active' : ''}`}
                onClick={() => onTypeClick('all')}
            >
                <span className="card-icon">📊</span>
                <span className="card-label">All</span>
                <span className="card-count">{totalCount.toLocaleString()}</span>
            </button>

            {/* Type-specific cards */}
            {cards.map(card => (
                <button
                    key={card.type}
                    className={`summary-card ${activeType === card.type ? 'active' : ''}`}
                    onClick={() => onTypeClick(card.type)}
                    style={{
                        '--card-color': card.color,
                        '--card-bg': `${card.color}15`
                    }}
                >
                    <span className="card-icon">{card.icon}</span>
                    <span className="card-label">{card.label}</span>
                    <span className="card-count">{card.count.toLocaleString()}</span>
                </button>
            ))}
        </div>
    );
}

export default EntitySummaryCards;
